import React from "react";
import {
  Button,
  Col,
  Divider,
  message,
  Popconfirm,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { DeleteOutlined } from "@ant-design/icons";
import {
  rowLayout,
  colLayout,
  DeviceModelCategory,
} from "../../Constants/Constants";
import { apiCallback } from "../../ApiHandlers/Common";
import { defaultSort, selectFilterFunction } from "../../Constants/Utilities";
import {
  convertDeviceModelList,
  convertModelDependencyListToApi,
} from "../../Helpers/DeviceModelHelpers";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ModelDependency extends React.Component {
  constructor(props) {
    super(props);
    console.log("ModelDependency props", props);
    this.state = {
      modelList: [],
      modelsToAdd: [],
      existingDependency: [],
      fetchingDependency: false,
      addingDependency: false,
    };
  }

  componentDidMount() {
    this.fetchModelDependency();
  }

  getColumns = () => [
    {
      title: "Model Number",
      dataIndex: "modelNumber",
      sorter: (a, b) => defaultSort(a.modelNumber, b.modelNumber),
      defaultSortOrder: "ascend",
    },
    {
      title: "Manufacturer",
      dataIndex: "manufacturer",
      sorter: (a, b) => defaultSort(a.manufacturer, b.manufacturer),
    },
    {
      title: "",
      dataIndex: "actions",
      align: "center",
      width: "10%",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="Remove dependency">
            <Popconfirm
              okText="Yes"
              cancelText="No"
              title="Are you sure want to remove dependency?"
              onConfirm={() => this.onDependencyRemove(record)}
            >
              <DeleteOutlined />
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];

  getModelList = (existDepend) => {
    const { deviceModelData } = this.props;
    const existingDependency = existDepend || this.state.existingDependency;
    return deviceModelData.filter(
      (item) =>
        item.category === DeviceModelCategory.accessory.value &&
        !existingDependency.some((t) => t.modelId === item.modelId)
    );
  };
  fetchModelDependency = () => {
    const { history, record, deviceModelDependencyApi } = this.props;
    console.log("fetchModelDependency...", record);
    this.setState({ fetchingDependency: true });
    const errorCallback = (error) => {
      const modelList = this.getModelList();
      this.setState({ modelList, fetchingDependency: false });
      message.error("Error fetching Model dependency list!");
    };
    const successCallback = (data) => {
      const existingDependency = convertDeviceModelList(
        data,
        "dependentdevicemodels"
      );
      const modelList = this.getModelList(existingDependency);
      this.setState({
        modelList,
        existingDependency,
        fetchingDependency: false,
      });
    };
    try {
      deviceModelDependencyApi.getDependentDeviceModels(
        record.modelId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  addModelToList = (model) => {
    console.log("addModelsToList", model);
    const { existingDependency } = this.state;
    const newExistingDependency = existingDependency.concat([model]);
    this.setState({
      existingDependency: newExistingDependency,
      modelList: this.getModelList(newExistingDependency),
    });
  };
  removeModelFromList = (model) => {
    console.log("removeModelsFromList", model);
    const { existingDependency } = this.state;
    const newExistingDependency = existingDependency.filter(
      (item) => item.modelId !== model.modelId
    );
    this.setState({
      existingDependency: newExistingDependency,
      modelList: this.getModelList(newExistingDependency),
    });
  };

  onDependencyAdd = () => {
    const { modelsToAdd } = this.state;
    const { history, record, deviceModelDependencyApi } = this.props;
    console.log("onDependencyAdd", record, modelsToAdd);
    this.setState({ addingDependency: true });
    const errorCallback = (error) => {
      this.setState({ addingDependency: false });
      message.error("Error adding Model dependency");
    };
    const successCallback = (data) => {
      this.setState({ addingDependency: false, modelsToAdd: [] });
      message.success(`Model dependency added successfully!`);
      this.fetchModelDependency();
    };
    try {
      const modelDependData = convertModelDependencyListToApi(modelsToAdd);
      deviceModelDependencyApi.updateDependentDeviceModels(
        record.modelId,
        modelDependData,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  onDependencyRemove = (item) => {
    const { history, record, deviceModelDependencyApi } = this.props;
    console.log("onDependencyRemove", item, record);
    this.removeModelFromList(item);
    const errorCallback = (error) => {
      this.addModelToList(item);
      message.error(`Error removing Dependency ${item.modelNumber}`);
    };
    const successCallback = () => {
      message.success(`Dependency ${item.modelNumber} removed successfully`);
    };
    try {
      deviceModelDependencyApi.removeDependencyDevicModels(
        record.modelId,
        item.modelId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  render() {
    const { onActionClick, record, parentBread } = this.props;
    const {
      modelList,
      existingDependency,
      modelsToAdd,
      addingDependency,
      fetchingDependency,
    } = this.state;
    return (
      <div className="model-dependency-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread.concat(`Device Model Dependency`)}
            onParentActionClick={onActionClick(null, null)}
          />
        </div>
        <Divider className="divider" />
        <div className="page-parent-title-container">
          <label>Device Model: {record.modelNumber}</label>
        </div>
        <Spin
          spinning={addingDependency}
          tip="Adding dependency, please wait..."
        >
          <Row {...rowLayout} style={{ marginTop: "10px" }}>
            <Col {...colLayout} className="display-flex-column">
              <label className="section-title">Add Models:</label>
              <Select
                mode="multiple"
                value={modelsToAdd}
                loading={fetchingDependency}
                style={{ width: "90%", maxWidth: "400px" }}
                placeholder={"Select Models"}
                filterOption={selectFilterFunction}
                onChange={(value) => this.setState({ modelsToAdd: value })}
              >
                {modelList.map((item) => (
                  <Select.Option key={item.modelId} title={item.modelNumber}>
                    {item.modelNumber}
                  </Select.Option>
                ))}
              </Select>
              <Button
                type="primary"
                className="add-button"
                onClick={this.onDependencyAdd}
              >
                Add
              </Button>
            </Col>
            <Col {...colLayout} className="display-flex-column">
              <label className="section-title header-label">
                Dependent Models:
              </label>
              <Table
                bordered
                size="small"
                columns={this.getColumns()}
                className="entity-table"
                style={{ width: "90%" }}
                loading={
                  fetchingDependency && { tip: "Loading Dependent Models..." }
                }
                dataSource={existingDependency}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

ModelDependency.propTypes = {
  record: PropTypes.object,
  deviceModelData: PropTypes.array,
  onActionClick: PropTypes.func,
  parentBread: PropTypes.array,

  deviceModelDependencyApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  deviceModelDependencyApi: state.apis.deviceModelDependencyApi,
});
const connectedModelDependency = connect(mapStateToProps)(ModelDependency);
export default withRouter(connectedModelDependency);
